// Matches the database default for users.annual_tax_rate (percent).
export const DEFAULT_ANNUAL_TAX_RATE = 2.2;
export const MIN_ANNUAL_TAX_RATE = 0;
export const MAX_ANNUAL_TAX_RATE = 5;

// Matches the database default for approaches.hold_months and its allowed range.
export const DEFAULT_HOLD_MONTHS = 6;
export const MIN_HOLD_MONTHS = 1;
export const MAX_HOLD_MONTHS = 360;

// Two-decimal percent string like "2.23" -> number, or null when it isn't a valid rate in range.
export const parseAnnualTaxRate = (input: string): number | null => {
  if (!/^\d+(\.\d{1,2})?$/.test(input.trim())) return null;
  const rate = Number(input);
  return rate >= MIN_ANNUAL_TAX_RATE && rate <= MAX_ANNUAL_TAX_RATE ? rate : null;
};
